<div style="display: flex; flex-direction: column; height: 100%" class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary w-100" id="modal-title">{{ headerText }}</h4>
    <div class="d-flex flex-column h-100">
      <div class="d-flex justify-content-center" >
        <i
          style="z-index: 9999; margin-right: 1rem; font-size:larger"
          class="bi bi-arrows-fullscreen text-danger"
          [ngClass]="{
            'bi-arrows-fullscreen': !toogleFullScreen,
            'bi-fullscreen-exit': toogleFullScreen
          }"
          [title]="toogleFullScreen ? 'Exit full screen' : 'Full screen'"
          color="warn"
          (click)="onFullScreen()"
        ></i>
        <i style="z-index: 9999; font-size: larger" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
      </div>
    </div>
  </div>
  <div class="modal-body">
		<div class="d-flex flex-column flex-grow-1 h-100">
			<form name="jobForm" (keyup.enter)="showOutputDialog ? onSubmit(jobForm) : ''" [formGroup]="jobForm">
				
					@if(!showOutputDialog){
						<mat-form-field style="width: 100%">
							<textarea
								matInput
								placeholder="Command"
								formControlName="command_jobCommand"
								style="height: 100px; width: 100%; background-color: #eeeeee; color: black; max-width: 100%; padding: 5px"
							></textarea>
							<mat-error *ngIf="jobForm.get('command_jobCommand').touched && jobForm.get('command_jobCommand').invalid">Command Required.</mat-error>
						</mat-form-field>
						<p>Note : View 'RunCmdOut.txt' file in jobs working directory to see the output of command.</p>
					} @else {
						<mat-form-field style="width: 100%">
							<mat-label>Command</mat-label>
							<input
								matInput
								placeholder="Command"
								formControlName="command_jobCommand"
								style="height: 35px; width: 100%; color: black; max-width: 100%; padding: 5px"
							/>
							<mat-error *ngIf="jobForm.get('command_jobCommand').touched && jobForm.get('command_jobCommand').invalid">Command Required.</mat-error>
						</mat-form-field>
					}
			</form>
			<div class="flex-grow-1">
				<mat-dialog-content #scrollMe class="mat-typography outputContent" *ngIf="showOutputDialog">
					<div #JobOutputDiv>
						<p readonly style="width: 100%; white-space: pre-wrap; padding: 0 .7rem; outline: none; color: black; font-weight: 600; border: none; background-color: white" [innerHTML]="jobOutput | highlight : searchTerm : regexCode"></p>
						<p *ngIf="dataEmpty" style="text-align: center; margin-top: 2%">No Output Generated.</p>
					</div>
				</mat-dialog-content>
			</div>
		</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" style="padding-inline: 5px; min-width: fit-content;" (click)="onCancel()">Cancel</button>
    <button type="button" class="btn btn-primary" style="padding-inline: 5px; min-width: fit-content;" cdkFocusInitial (click)="onSubmit(jobForm)">
      {{ submitButtonText }}
    </button>
  </div>
	<ngx-spinner bdColor="rgba(0,0,0,0)" size="default" zIndex="1" color="white" type="ball-spin" [fullScreen]="true" style="z-index: 1000 !important"
		><p style="color: var(--s-text-color) !important">Running Command ...</p></ngx-spinner
	>
</div>
